export const routeNames = {
    DEFAULT: "default",
    SELECT_DEVICE: "select-device",
    SELECT_VOICE: "select-voice",
    SELECT_DATA: "select-data",
    CONFIRM_PLAN_DETAILS: "confirm-plan-details",
    CONFIRM_OTP: "confirm-otp",
    RENEW_CONTRACT: "renew-contract",
};
